import React, { useState } from 'react';
import { FaPlus, FaTrashAlt } from 'react-icons/fa';
import AssetSelect from '../../DropDowns/AssetDropDown/AssetDropDown';

interface AssetDetailsProps {
  selectedAsset: string;
  setSelectedAsset: (asset: string) => void;
  assetPercentage: string;
  setAssetPercentage: (percentage: string) => void;
  assets: { asset_id: number; asset_name: string; percent_ownership: string }[];
  setAssets: React.Dispatch<React.SetStateAction<{ asset_id: number; asset_name: string; percent_ownership: string }[]>>;
  handleAddAsset: () => void;
  disabled: boolean;
  className?: string;
  onFocus?: (fieldName: string) => void;
  // onFocus?: () => void;
  highlightClass?: string;
  modifiedFields: Record<string, boolean>;
  setModifiedFields: React.Dispatch<React.SetStateAction<Record<string, boolean>>>;
}

const AssetDetails: React.FC<AssetDetailsProps> = ({
  selectedAsset,
  setSelectedAsset,
  assetPercentage,
  setAssetPercentage,
  assets,
  setAssets,
  handleAddAsset,
  disabled,
  className,
  onFocus,
  highlightClass,
  modifiedFields,
  setModifiedFields,
}) => {
  const [selectedAssetName, setSelectedAssetName] = useState<string>("");

  return (
    <div className="p-4 bg-[#f9f9f9] border border-gray-300 rounded-lg shadow-sm mt-8 w-full">
      <label className="block text-gray-600 mb-2 font-medium text-lg">Asset Details</label>

      {/* Responsive Container for Asset Selection and Percentage Input */}
      <div className="mb-4 flex flex-col sm:flex-row sm:space-x-4 md:space-x-6">
        {/* Asset Select */}
        <div className="flex-1">
          <label className="block text-gray-600 mb-2 text-sm">Asset</label>
          <AssetSelect
            selectedAsset={selectedAsset}
            onChange={(assetId, assetName) => {
              setSelectedAsset(assetId);
              setSelectedAssetName(assetName);
              setModifiedFields((prev) => ({ ...prev, selectedAsset: true }));
            }}
            disabled={disabled}
            onFocus={() => onFocus?.("selectedAsset")}

            // className="w-full p-1 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 bg-[#f9f9f9] text-gray-900  text-sm ${highlightClass}"
            className={`w-full p-1 border rounded-lg text-sm ${highlightClass}`}

          />
        </div>

        {/* Percentage Input */}
        <div className="flex-1">
          <label className="block text-gray-600 mb-2 text-sm">Percentage</label>
          <input
            // className="w-full p-3 border border-gray-300 rounded-lg bg-[#f9f9f9] text-gray-900 font-bold text-sm"
            className={`w-full p-3 border rounded-lg text-sm font-bold ${highlightClass}`}
            type="text"
            value={assetPercentage}
            // onChange={(e) => setAssetPercentage(e.target.value)}
            onChange={(e) => {
              const value = e.target.value;
              setAssetPercentage(value);
              setModifiedFields(prev => ({ ...prev, assetPercentage: true }));
            }}
            placeholder="%"
            disabled={disabled}
            onFocus={() => onFocus?.("assetPercentage")}
          />
        </div>
      </div>

      {/* Add Button */}
      <button
        onClick={() => {
          // Use selectedAssetName when adding asset
          setAssets([...assets, {
            asset_id: parseInt(selectedAsset),
            asset_name: selectedAssetName,
            percent_ownership: assetPercentage,
          }]);
          handleAddAsset();
        }}
        className="w-full sm:w-auto px-4 py-2 bg-[#a6a9ac] text-white rounded-lg hover:bg-[#474747] transition-colors duration-300 text-sm flex items-center justify-center mt-2"
        disabled={disabled || !selectedAsset || !assetPercentage}
      >
        <FaPlus className="mr-2" /> Add
      </button>

      {/* Asset Table - Responsive */}
      <div className="mt-4 max-h-64 overflow-y-auto border border-gray-200 p-3 rounded-lg shadow-sm bg-white">
        {assets.length === 0 ? (
          <p className="text-gray-500 text-center py-4">No assets added yet.</p>
        ) : (
          assets.map((entry, index) => (
            <div key={index} className="grid grid-cols-[1fr_auto_auto] items-center p-2 hover:bg-gray-100 rounded-lg">
              <span className="text-gray-800 break-words">{entry.asset_name}</span>
              <span className="text-gray-900 font-bold text-right pr-4">{entry.percent_ownership}%</span>
              <div className="pl-4">
                <button
                  onClick={() => setAssets(assets.filter((_, i) => i !== index))}
                  className="text-red-500 hover:text-red-700"
                  disabled={disabled}
                >
                  <FaTrashAlt />
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default AssetDetails;
